<template>
    <div class="prefooter">
        <div class="container">
            <div class="gr-12">
                <div class="prefooter__inner">
                    <div class="prefooter__links">
                        <ul>
                            <li>
                                <router-link to="/privacy">Privacy policy</router-link>
                            </li>
                            <li>
                                <router-link to="/cookie">Cookie policy</router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="prefooter__links">
                        <ul>
                            <li>
                                <router-link to="/contact">Contact Us</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'prefooter',

        data() {
            return {}
        }
    };
</script>


<style scoped lang="scss">
    @import "@/scss/modules/_prefooter.scss";
</style>